import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

export const Route = createFileRoute('/admin/jobs/$id/quality')({
  component: QualityScore,
});

function QualityScore() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Quality Score Analysis</CardTitle>
          <CardDescription>
            Comprehensive quality assessment based on data completeness, accuracy, and engagement
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Alert>
            <AlertCircle className="h-4 w-4" />
            <AlertDescription>
              Quality score breakdown showing completeness, accuracy, extraction confidence, field match,
              duplicate penalty, and engagement metrics. Implementation coming soon.
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </div>
  );
}
